import { FC, ReactNode } from 'react';
import { SwitchText, SwitchStatus } from 'views/business/BusinessListing/components/SwitchText/SwitchText';
import './ToolConditionItem.scss';

/**
 * Componente wrapper que muestra una condición de la herramienta con su label y control
 * @param label - Etiqueta de la condición
 * @param value - Valor actual de la condición (usado solo si no se pasa customControl)
 * @param onChange - Función que se ejecuta al cambiar el valor (usado solo si no se pasa customControl)
 * @param disabled - Si el control está deshabilitado (usado solo si no se pasa customControl)
 * @param customControl - Componente personalizado para el control (ej: selector de idioma)
 * @param isFirst - Si es el primer elemento de la lista para aplicar border-top
 */
const ToolConditionItem: FC<ToolConditionItemProps> = ({ 
  label, 
  value, 
  onChange, 
  disabled,
  customControl,
  isFirst,
  customStyles
}) => {
  const status = value ? SwitchStatus.ACTIVE : SwitchStatus.INACTIVE;

  const handleChange = (newValue: boolean | React.ChangeEvent<HTMLInputElement>) => {
    if (!disabled && onChange) {
      const boolValue = typeof newValue === 'boolean' ? newValue : newValue?.target?.checked;
      onChange(boolValue);
    }
  };

  const renderControl = () => {
    if (customControl)  return customControl;
    
    return (
      <div className={disabled ? 'switchDisabled' : ''}>
        <SwitchText status={status} handleChangeStatus={handleChange} activeLabel="Sí" inactiveLabel="No" isDisabled={disabled} />
      </div>
    );
  };

  return (
    <div className={`toolConditionItem ${isFirst ? 'first' : ''}`} style={customStyles}>
      <span className="conditionLabel">{label}</span>
      {renderControl()}
    </div>
  );
};

interface ToolConditionItemProps {
  label: string;
  value?: boolean;
  onChange?: (value: boolean) => void;
  disabled?: boolean;
  customControl?: ReactNode;
  isFirst?: boolean;
  customStyles?: React.CSSProperties;
}

export default ToolConditionItem;

